import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './NoSubscriptionsLanding.style';

export function NoSubscriptionsLanding({ businessEntity }) {
  const navigate = useNavigate();
  const { uuid, name, domesticJurisdiction } = businessEntity;
  const isFreeDash = domesticJurisdiction === 'XX';

  return (
    <Styled.NoSubscriptionsPaper>
      <Stack alignItems="center" gap={3}>
        <Styled.NoSubscriptionsHeading size="2xl" weight="bold" family="secondary" align="center">
          {isFreeDash ? (
            <FormattedMessage id="dashboard.subscriptions.noSubscriptions.heading" />
          ) : (
            <FormattedMessage
              id="dashboard.subscriptions.noSubscriptions.headingForEntity"
              values={{ entityName: name }}
            />
          )}
        </Styled.NoSubscriptionsHeading>
        <Text size="md" color="secondary" align="center">
          <FormattedMessage id="dashboard.subscriptions.noSubscriptions.body" />
        </Text>
        <Button
          variant="contained"
          onClick={() => navigate(`/dashboard/${uuid}`)}
          clickstreamProps={{ elementName: 'no_subscriptions_back_to_home_button' }}
        >
          <FormattedMessage id="dashboard.subscriptions.noSubscriptions.backToHome" />
        </Button>
      </Stack>
    </Styled.NoSubscriptionsPaper>
  );
}

NoSubscriptionsLanding.propTypes = {
  businessEntity: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    domesticJurisdiction: PropTypes.string.isRequired,
  }).isRequired,
};
